
import { fromEvent as observableFromEvent } from 'rxjs';

import { mergeWith, mergeMap, repeat, takeUntil } from 'rxjs/operators';
import { Component, Input, forwardRef, ViewChild, ElementRef, HostBinding, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services/authentication.service';

@Component({
	selector: 'bb-status',
	templateUrl: './bb-status.component.html',
	styleUrls: ['./bb-status.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbStatusComponent),
		multi: true
	}]
})

export class BbStatusComponent implements ControlValueAccessor, OnInit {

	@Input() valueOn: string | boolean = 'published';
	@Input() valueOff: string | boolean = 'draft';
	@Input() labelOn: string;
	@Input() labelOff: string;
	@Input() simpleMode = true;
	@Input() standAlone = false;

	@ViewChild('toggle', { static: true }) toggle: ElementRef;

	value: boolean;
	propagateChange: any;
	_publishRight = false;

	@HostBinding('class.disabled')
	get publishRight() {
		return !this._publishRight;
	}

	constructor(private translate: TranslateService, private authenticationService: AuthenticationService) {
		this.authenticationService.hasPermission('publish').subscribe(hasRight => this._publishRight = hasRight);
	}

	ngOnInit() {
		if (!this.labelOn && this.labelOn !== '') {
			this.labelOn = this.translate.instant('PUBLISHED');
		}

		if (!this.labelOff && this.labelOff !== '') {
			this.labelOff = this.translate.instant('DRAFT');
		}

		if (this.publishRight && !this.simpleMode) {
			const mouseDownObservable = observableFromEvent(this.toggle.nativeElement, 'mousedown');
			const mouseUpObservable = observableFromEvent(document.body, 'mouseup');
			const mouseLeaveObservable = observableFromEvent(document.body, 'mouseleave');
			const mouseMoveObservable = observableFromEvent(document.body, 'mousemove');

			let startX: number;

			mouseDownObservable.pipe(mergeMap((mouseDownEvent: MouseEvent) => {
				startX = mouseDownEvent.clientX;
				return mouseMoveObservable.pipe(takeUntil(mouseUpObservable), takeUntil(mouseLeaveObservable));
			}),
			repeat())
				.subscribe((event: MouseEvent) => {
					const start = (this.value ? 31 : 1);
					const diff = (event.clientX - startX);

					let newLeft = (start + diff);
					newLeft = Math.min(newLeft, 31);
					newLeft = Math.max(newLeft, 1);

					this.toggle.nativeElement.style.left = newLeft.toString() + 'px';
				}
				);

			mouseUpObservable.pipe(mergeWith(mouseLeaveObservable)).subscribe((event: MouseEvent) => {

				if (!this.toggle.nativeElement.style.left) {
					return;
				}

				if (parseInt(this.toggle.nativeElement.style.left, 10) < 16) {
					this.valueChanged(false);
				} else {
					this.valueChanged(true);
				}
			});
		}
	}

	valueChanged(value: boolean) {

		const valueChanged = (this.value !== value);

		this.value = value;
		if (!this.simpleMode) {
			this.toggle.nativeElement.style.left = (this.value ? 31 : 1).toString() + 'px';
		}

		if (valueChanged && this.propagateChange) {
			this.propagateChange(this.value ? this.valueOn : this.valueOff);
		}
	}

	writeValue(value: string) {
		this.value = (value === this.valueOn);
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
